import { render, staticRenderFns } from "./SupportSkillViewer.vue?vue&type=template&id=be4af1ea&"
import script from "./SupportSkillViewer.vue?vue&type=script&lang=js&"
export * from "./SupportSkillViewer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports